import { AdminPanelHeader } from './AdminPanelHeader';
import { AdminPanelFooter } from './AdminPanelFooter';
import { ChannelNameInputField } from './ChannelNameInputField';
import Grid from '@mui/material/Grid'
import { ChannelUsersList } from './ChannelUsersList';
import { UserList } from './UserList';

import { useWorkspaceController } from '../../context/WorkspaceController';
import { useAdminPanelFormState } from './context/AdminPanelFormContext';
import { Delete, Save } from '@mui/icons-material';
import { Box, Button, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';

export const EditChannel = (channel) => {
  const { closeAdminPanel } = useWorkspaceController();
  const {name, handleInputChange, handleSubmit, errors } = useAdminPanelFormState()
  const barnUser = useSelector(state => state.user.barnUser)

  if(!channel || !channel.channel || !channel.channel.type) {
    closeAdminPanel();
    return <Box />;
  }

  return (
    <div className='admin-panel__form'>
      <AdminPanelHeader onClose={closeAdminPanel} title='Edit Channel'/>
      <ChannelNameInputField name={name} error={errors.name} onChange={handleInputChange} />
        <Grid container spacing={1} sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          position: 'relative',
          alignItems: 'center',
          overflow: 'auto'}}>
          <Grid item xs={channel.channel.type === 'messaging' ? 12 : 6}>
            <ChannelUsersList />
          </Grid>
          {
            channel.channel.type === 'team' && (
              <Grid item xs={6}>
                <UserList />
            </Grid>
            )
          }
      </Grid>
      <Box sx={{ textAlign: 'right', m: 2}}>
        {
          ((channel.channel.type === 'messaging' && channel.channel.data.created_by.auth0_user_id === barnUser.auth0UserId)
            || ((barnUser.roles.indexOf('admin') >= 0 || barnUser.roles.indexOf('owner') >= 0)) && channel.channel.data.team === barnUser.barn.tenant)
          && (
            <Tooltip size="small" title="Only the creator of a channel can delete it"><Button endIcon={<Delete />} color="error" onClick={() => channel.channel.delete()} sx={{ mr: 2 }}>Delete Channel</Button></Tooltip>
          )
        }
        <Button endIcon={<Save />} variant="contained" onClick={handleSubmit}>Save</Button>
      </Box>
    </div>
  );
};
